





















































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import MasterFieldSearch from '@/app/components/MasterField/MasterFieldSearch.vue'
import MasterFieldListHeader from '@/app/components/MasterField/MasterFieldListHeader.vue'
import MasterFieldList from '@/app/components/MasterField/MasterFieldList.vue'
import Pagination from '@/app/components/Common/Pagination.vue'
/* api */
import MasterFieldListApi from '@/app/model/api/masterFieldListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    MasterFieldSearch,
    MasterFieldListHeader,
    MasterFieldList,
    Pagination
  }
})
export default class MasterField extends Vue {
  private totalCount: number = 0
  private currentPage: number = 1
  private notDataMessage: boolean = false
  private showLoading: boolean = true
  private isRequesting: boolean = false
  private complateMessage: string = this.$store.state.alertState.message
  private masterFieldData: any = {}

  created () {
    this.getMasterFieldList()
  }

  private getMasterFieldList () {
    (async () => {
      this.isRequesting = true
      const data = {
        word: this.$store.state.masterFieldState.searchText,
        sensor_word: this.$store.state.masterFieldState.searchSensorText,
        order_name: this.$store.state.masterFieldState.orderName,
        sort: this.$store.state.masterFieldState.sortAsc,
        page: this.$store.state.masterFieldState.currentPage
      }
      this.currentPage = this.$store.state.masterFieldState.currentPage

      const result = await MasterFieldListApi.getMasterFieldList(data)

      if (result.isOk()) {
        this.masterFieldData = result.getPayload()
        this.totalCount = result.getPayload().total_count

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private doMasterFieldSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    let pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.masterFieldState.orderName) {
      if (this.$store.state.masterFieldState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('masterFieldState/setCurrentPage', 1)
    this.$store.commit('masterFieldState/setOrderName', data)
    this.$store.commit('masterFieldState/setSortAsc', sort)
    this.getMasterFieldList()
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    let pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    this.$store.commit('masterFieldState/setCurrentPage', 1)
    this.$store.commit('masterFieldState/setOrderName', 'created_at')
    this.$store.commit('masterFieldState/setSortAsc', false)
    this.getMasterFieldList()
  }

  private scrollTop () : any {
    let masterFieldArea: any = document.getElementById('listContainer')!
    masterFieldArea.scrollTop = 0
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('masterFieldState/setCurrentPage', page)
      this.getMasterFieldList()
    }
  }
}
